import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M12.1787 18.4393L18.3269 12.2911L19.3875 13.3518L11.959 20.7803C11.6661 21.0732 11.1912 21.0732 10.8983 20.7803L3.46973 13.3518L4.53039 12.2911L10.6787 18.4394L10.6787 1H12.1787L12.1787 18.4393Z" />
  </svg>
);
